import friends from './assets/friend.gif'
import love from './assets/love.gif'
import affection from './assets/affection.gif'
import marriages from './assets/marriage.gif'
import enemies from './assets/enemy.gif'
import siblings from './assets/siblings.gif'

export const constants = {
  FRIENDS: "FRIENDS",
  LOVE: "LOVE",
  AFFECTION: "AFFECTION",
  MARRIAGE: "MARRIAGE",
  ENEMIES: "ENEMIES",
  SIBLINGS: "SIBLINGS",
  FRIENDS_DES: '"A strong bond of friendship is in the stars for you two!"',
  LOVE_DES: '"Cupid has struck! You share a deep romantic connection."',
  AFFECTION_DES: '"A warm and caring bond ties you together."',
  MARRIAGE_DES:
    '"Wedding bells are ringing! A lifelong partnership is possible."',
  ENEMIES_DES:
    '"Watch out! Your energies clash, but rivalry can lead to growth."',
  SIBLINGS_DES: '"More than just friends—you’re like family!"',
  FLAMES: 'FLAMES'
};


export const handleHeader = (Relationship: any) => {
  switch (Relationship) {
    case "F":
      return constants.FRIENDS;
    case "L":
      return constants.LOVE;
    case "A":
      return constants.AFFECTION;
    case "M":
      return constants.MARRIAGE;
    case "E":
      return constants.ENEMIES;
    case "S":
      return constants.SIBLINGS;
    default:
      return "Invalid Result" ;
  }
};

export const handleDes = (Relationship: any) => {
  switch (Relationship) {
    case "F":
      return constants.FRIENDS_DES;
    case "L":
      return constants.LOVE_DES;
    case "A":
      return constants.AFFECTION_DES;
    case "M":
      return constants.MARRIAGE_DES;
    case "E":
      return constants.ENEMIES_DES;
    case "S":
      return constants.SIBLINGS_DES;
    default:
      return "Invalid Result";
  }
};

export const getImage = (res: any) => {
  switch (res) {
    case "F":
      return friends;
    case "L":
      return love;
    case "A":
      return affection;
    case "M":
      return marriages;
    case "E":
      return enemies;
    case "S":
      return siblings;
    default:
      return "Invalid Result";
  }
};



